const e = {
  name: "Expand",
  dimensions: { width: 20, height: 20 },
  content: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2929 7.29289C10.9024 7.68342 10.9024 8.31658 11.2929 8.70711C11.6834 9.09763 12.3166 9.09763 12.7071 8.70711L18 3.41421V7C18 7.55228 18.4477 8 19 8C19.5523 8 20 7.55228 20 7V1C20 0.447715 19.5523 0 19 0H13C12.4477 0 12 0.447715 12 1C12 1.55228 12.4477 2 13 2H16.5858L11.2929 7.29289Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.70711 11.2929C8.31658 10.9024 7.68342 10.9024 7.29289 11.2929L2 16.5858L2 13C2 12.4477 1.55229 12 1 12C0.447716 12 0 12.4477 0 13V19C0 19.5523 0.447715 20 1 20L7 20C7.55228 20 8 19.5523 8 19C8 18.4477 7.55228 18 7 18L3.41421 18L8.70711 12.7071C9.09763 12.3166 9.09763 11.6834 8.70711 11.2929Z" fill="currentColor"/>`
};
export {
  e as Expand
};
